import { useEffect, useRef } from "react";
import { useFinePointer, useReducedMotion } from "../../lib/motion";

export const CustomCursor = () => {
  const fine = useFinePointer();
  const reduced = useReducedMotion();
  const ring = useRef(null);

  useEffect(() => {
    if (!fine || reduced) return;
    const el = ring.current;
    let x = -100, y = -100, tx = -100, ty = -100, raf;
    const move = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      el.style.opacity = "1";
      el.classList.toggle("is-hover", !!e.target.closest?.("a, button, [data-cursor]"));
    };
    const leave = () => (el.style.opacity = "0");
    const loop = () => {
      x += (tx - x) * 0.2;
      y += (ty - y) * 0.2;
      el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("pointermove", move, { passive: true });
    document.addEventListener("mouseleave", leave);
    loop();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", move);
      document.removeEventListener("mouseleave", leave);
    };
  }, [fine, reduced]);

  if (!fine || reduced) return null;
  return <div ref={ring} className="cursor-ring" style={{ opacity: 0 }} aria-hidden="true" data-testid="custom-cursor" />;
};
